module.exports = __webpack_public_path__ + "static/img/win4.c0063c95.png";